// import React from "react";
// import {Typography,Button,Container,Box,Grid,Card,
//   CardContent, List, ListItem, ListItemIcon, ListItemText 
// } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import Footer from "../../Common/Footer";

// import screenimage from "../../Logos/screenimage.png";
// import ParentTrust from "../../Logos/Elder&childcarePage/ParentsTrust.png";


// import mainimage from "../../Logos/DiagnoisticDelivery/TopBanner.png";
// import prescription from "../../Logos/DiagnoisticDelivery/prescription.png";
// import refills from "../../Logos/DiagnoisticDelivery/refills.png";
// import emergencymedicine from "../../Logos/DiagnoisticDelivery/emergencymedicine.png";
// import essentials from "../../Logos/DiagnoisticDelivery/essentials.png";  
// import coldchain from "../../Logos/DiagnoisticDelivery/coldchain.png";
// import MedicineDelivery from "../../Logos/DiagnoisticDelivery/MedicineDelivery.png";
// import homesample from "../../Logos/DiagnoisticDelivery/homesample.png";
// import widerange from "../../Logos/DiagnoisticDelivery/widerange.png";
// import labs from "../../Logos/DiagnoisticDelivery/labs.png";
// import digitalreport from "../../Logos/DiagnoisticDelivery/digitalreport.png";
// import followup from "../../Logos/DiagnoisticDelivery/followup.png";
// import DiagnosticSampleCollection from "../../Logos/DiagnoisticDelivery/DiagnosticSampleCollection.png";
// const MedicineDiagnosticDelivery = () => {


//     return (
//         <Box sx={{ overflowX: "hidden" }}>
//           <HeroSection />
//           <OverViewSection/>
//           <MedicineDeliverySection/>
//           <ScreenImageSection />
//           <DiagnosticCollectionSection/>
//           <ScreenImageSection />
//           <WhyAyuja/>
//           <Footer/>
//         </Box>
//       );
//     }
    
//       function HeroSection() {
//         const navigate = useNavigate();
//           return (

//                 <Box
//                 sx={{
//                     width: { xs: "100%", md: "100%" },
//                     minHeight: "350px",
//                     backgroundImage: `url(${mainimage})`,
//                     backgroundSize: "cover",       
//                     backgroundPosition: "center", 
//                     p: 4,                      
//                     color: "#fff",                
//                     position: "relative",
//                 }}
//                 >
//                 {/* Optional overlay for better text visibility */}
//                 <Box
//                     sx={{
//                     position: "absolute",
//                     top: 0,
//                     left: 0,
//                     right: 0,
//                     bottom: 0,
//                     bgcolor: "rgba(0,0,0,0.4)", // dark overlay
//                     borderRadius: "16px",
//                     }}
//                 />
//                 {/* Content */}
//                 <Box sx={{ position: "relative", zIndex: 1, ml: 6 }}>
//                     <Typography
//                     variant="body1"
//                     sx={{
//                         mb: 3,
//                         fontSize: "75.21px",
//                         fontFamily: '"Montserrat", sans-serif',
//                         lineHeight: "1.3",
//                     }}
//                     >
//                       Fast, Reliable Healthcare<br/>
//                       Essentials Delivered to<br/>
//                       Your Doorstep
//                     </Typography>
//                     <Button
//                     variant="contained"
//                     onClick={() => navigate("/book-appointment")}
//                     sx={{
//                         backgroundColor: '#F9F2FF',
//                         color: '#006D77',
//                         px: 4,
//                         textTransform: "none",borderRadius:"50px",
//                         fontWeight: "bold",
//                         fontFamily: '"Montserrat", sans-serif',
//                         "&:hover": {
//                         background: "#fff",
//                         },
//                     }}
//                     >
//                     Book Now
//                     </Button>
//                 </Box>
//                 </Box>
//           );
//         }
        





// function OverViewSection() {
//     return (
//       <Box sx={{minHeight: "40vh",display: "flex",flexDirection: "column",justifyContent: "center",alignItems: "center",px: 1,py: 2,bgcolor: "#fff",}}>
//         <Container>
//           <Typography
//             variant="h4"
//             gutterBottom
//             sx={{ textAlign: "center", color: "#000000", fontFamily: "Montserrat Alternates, sans-serif", fontWeight: "bold",}}>
//             Overview
//           </Typography>
  
//           <Typography
//             variant="body1"
//             sx={{maxWidth: 1000,fontSize: "1.3em",color: "#0161AB",textAlign: "center",mx: "auto", }} >
//               At 
//             <Box component="span" sx={{ fontSize: "1.8rem", fontWeight: "bold" }}>
//                  Ayuja
//             </Box>{" "}
//             , we understand that timely access to medicines and diagnostic reports is crucial
//              for maintaining good health. Our seamless delivery service ensures that prescriptions, medical supplies, and lab reports reach your home safely,
//              without the need to step out — especially when you or your loved ones are unwell. 
//           </Typography>
//         </Container>
//       </Box>
//     );
//   }

//   const services = [
//     {
//       title: "Prescription-Based Delivery",
//       desc: "Upload your prescription, and we’ll take care of the rest.  ",
//       image: prescription,
//     },
//     {
//       title: "Scheduled Medicine Refills",
//       desc: "Never miss a dose with auto-scheduled refill services. ",
//       image: refills,
//     },
//     {
//       title: "Emergency Medicine Requests",
//       desc: "Priority delivery for critical and time-sensitive medications. ",
//       image: emergencymedicine,
//     },
//     {
//       title: "Chronic Care Essentials",
//       desc: "Hassle-free delivery of medicines for long-term conditions like diabetes, hypertension, and thyroid.",
//       image: essentials,
//     },
//     {
//       title: "Cold Chain Compliance",
//       desc: "Proper handling and storage of temperature-sensitive medicines during transport. ",
//       image: coldchain,
//     }
//   ];

//   function MedicineDeliverySection() {
//       return (

//     <Box sx={{backgroundColor: "#006D77",py: 0,mb: 0,position: "relative",}}>
//       <Container sx={{ py: 3, mb: 0 }}>
//         <Typography
//           variant="h4"
//           align="center"
//           gutterBottom
//           sx={{
//             fontWeight: "bold",
//             fontFamily: '"Montserrat", sans-serif',
//             color: "#B3FFC4",
//           }}
//         >
//           Medicine Delivery
//         </Typography>
//         <Typography
//           variant="body1"
//           sx={{ mb: 3, color: "#B3FFC4", lineHeight: 1.6, textAlign: "center" }}
//         >
//           Prescriptions at Your Fingertips 
//         </Typography>
//         <Box sx={{ py: 1 }}>
//           <Grid container spacing={4} justifyContent="center">
//             {services.map((service, idx) => (
//               <Grid item xs={12} sm={6} md={4} key={idx} justifyContent="center">
//                 <Box display="flex" justifyContent="center">
//                   <Card
//                     sx={{
//                       display: "flex",
//                       flexDirection: "column",
//                       justifyContent: "space-between",
//                       backgroundColor: "#B3FFC4",
//                       border: "1.5px solid #B3FFC4",
//                       borderRadius: 2,
//                       p: 2,
//                       maxWidth: 320,
//                     }}
//                   >
//                     <CardContent
//                       sx={{
//                         flexGrow: 1,
//                         display: "flex",
//                         flexDirection: "column",
//                       }}
//                     >
//                       <Box display="flex" alignItems="center">
//                         <Box
//                           sx={{
//                             width: 56,
//                             height: 56,
//                             backgroundColor: "#22577A",
//                             borderRadius: "50%",
//                             overflow: "hidden",
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                             mr: 2,
//                             flexShrink: 0,
//                           }}
//                         >
//                           <img
//                             src={service.image}
//                             alt={service.title}
//                             style={{
//                               width: "100%",
//                               height: "100%",
//                               objectFit: "cover",
//                             }}
//                           />
//                         </Box>

//                         <Typography
//                           variant="h6"
//                           sx={{
//                             fontWeight: 700,
//                             fontFamily: '"Montserrat", sans-serif',
//                             color: "#000000",
//                             flex: 1,
//                             wordBreak: "break-word",
//                           }}
//                         >
//                           {service.title}
//                         </Typography>
//                       </Box>

//                       <Typography
//                         variant="body2"
//                         sx={{
//                           mt: 2,
//                           fontFamily: '"Montserrat", sans-serif',
//                           color: "#000000",
//                           flexGrow: 1,
//                           wordBreak: "break-word",
//                         }}
//                       >
//                         {service.desc}
//                       </Typography>
//                     </CardContent>
//                   </Card>
//                 </Box>
//               </Grid>
//             ))}
//           </Grid>
//         </Box>
//       </Container>

//       <Box
//         component="img"
//         src={MedicineDelivery}
//         alt="Medicine Delivery"
//         sx={{
//             position: "absolute",
//             bottom: 0,
//             right: 0,
//             width: { xs: "150px", md: "380px" }, 
//             height: "auto",
//             pointerEvents: "none", 
//           }}
//       />
//     </Box>
//       );
//     }
    
//     function ScreenImageSection() {
//           return (
//     <Box component="img" src={screenimage} alt="About Us"
//     sx={{width: "100%",height: "10vh",objectFit: "cover",borderRadius: "0px 0px 100px 0px",display: "block"}}
//   />
// );
// }


// const childservices = [
//     {
//       title: "Home Sample Collection",
//       desc: "Certified phlebotomists collect blood, urine, and swab samples at your convenience.",
//       image: homesample,
//     },
//     {
//       title: "Wide Range of Tests",
//       desc: "From routine health checkups to advanced diagnostics, all tests are covered. ",
//       image: widerange,
//     },
//     {
//       title: "Partnered with Trusted Labs",
//       desc: "We collaborate with NABL-accredited diagnostic centers for accuracy and reliability. ",
//       image: labs,
//     },
//     {
//       title: "Digital Report Access",
//       desc: "Get your reports directly via email or Ayuja app, with printed copies available on request. ",
//       image: digitalreport,
//     },
//     {
//       title: "Doctor Follow-Up Coordination",
//       desc: "Optional consultation scheduling after report delivery for seamless care.",
//       image: followup,
//     }
//   ];


// function DiagnosticCollectionSection() {
//     return (

//   <Box sx={{backgroundColor: "#006D77",py: 0,mb: 0,position: "relative",}}>
//     <Container sx={{ py: 3, mb: 0 }}>
//       <Typography
//         variant="h4"
//         align="center"
//         gutterBottom
//         sx={{
//           fontWeight: "bold",
//           fontFamily: '"Montserrat", sans-serif',
//           color: "#B3FFC4",
//         }}
//       >
//         Diagnostic Sample Collection & Report Delivery
//       </Typography>
//       <Typography
//         variant="body1"
//         sx={{ mb: 3, color: "#B3FFC4", lineHeight: 1.6, textAlign: "center" }}
//       >
//         Lab Tests Without the Wait
//       </Typography>
//       <Box sx={{ py: 1 }}>
//         <Grid container spacing={4} justifyContent="center">
//           {childservices.map((service, idx) => (
//             <Grid item xs={12} sm={6} md={4} key={idx} justifyContent="center">
//               <Box display="flex" justifyContent="center">
//                 <Card
//                   sx={{
//                     display: "flex",
//                     flexDirection: "column",
//                     justifyContent: "space-between",
//                     backgroundColor: "#B3FFC4",
//                     border: "1.5px solid #B3FFC4",
//                     borderRadius: 2,
//                     p: 2,
//                     maxWidth: 320,
//                   }}
//                 >
//                   <CardContent
//                     sx={{
//                       flexGrow: 1,
//                       display: "flex",
//                       flexDirection: "column",
//                     }}
//                   >
//                     <Box display="flex" alignItems="center">
//                       <Box
//                         sx={{
//                           width: 56,
//                           height: 56,
//                           backgroundColor: "#22577A",
//                           borderRadius: "50%",
//                           overflow: "hidden",
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                           mr: 2,
//                           flexShrink: 0,
//                         }}
//                       >
//                         <img
//                           src={service.image}
//                           alt={service.title}
//                           style={{
//                             width: "100%",
//                             height: "100%",
//                             objectFit: "cover",
//                           }}
//                         />
//                       </Box>

//                       <Typography
//                         variant="h6"
//                         sx={{
//                           fontWeight: 700,
//                           fontFamily: '"Montserrat", sans-serif',
//                           color: "#000000",
//                           flex: 1,
//                           wordBreak: "break-word",
//                         }}
//                       >
//                         {service.title}
//                       </Typography>
//                     </Box>

//                     <Typography
//                       variant="body2"
//                       sx={{
//                         mt: 2,
//                         fontFamily: '"Montserrat", sans-serif',
//                         color: "#000000",
//                         flexGrow: 1,
//                         wordBreak: "break-word",
//                       }}
//                     >
//                       {service.desc}
//                     </Typography>
//                   </CardContent>
//                 </Card>
//               </Box>
//             </Grid>
//           ))}
//         </Grid>
//       </Box>
//     </Container>

//     <Box
//       component="img"
//       src={DiagnosticSampleCollection}
//       alt="Diagnostic Sample Collection"
//       sx={{
//           position: "absolute",
//           bottom: 0,
//           right: 0,
//           width: { xs: "250px", md: "420px" }, 
//           height: "auto",
//           pointerEvents: "none", 
//         }}
//     />
//   </Box>
//     );
//   }



//   function WhyAyuja() {
//     return (
//       <Box
//         sx={{
//           display: "flex",
//           alignItems: "center",
//           backgroundColor: "#006699",
//           color: "white",
//         }}
//       >

//         {/* Left Section */}
//         <Box sx={{ flex: 1,textAlign: "center"}}>
//           <Typography
//             variant="h4"
//             sx={{ fontWeight: "bold",textAlign: "center",ml:40,}}
//           >
//             Why Choose Ayuja for Medicine & Diagnostic Delivery? 
//           </Typography>
//           <List sx={{width: "80%",mx: "auto",fontSize: "30px"}}>  
//             {[
//               "Hassle-free booking through app or helpline ",
//               "Trained delivery staff and medical professionals",
//               "Secure, tamper-proof packaging and verified reports ",
//               "Timely reminders for reorders and test schedules ",
//               "Designed for elderly, busy professionals, and post-op patients ",
//             ].map((text, i) => (
//               <ListItem key={i} sx={{ py: 0.5 }}>
//                 <ListItemIcon>
//                   <CheckCircleIcon sx={{ color: "#4CAF50" }} />
//                 </ListItemIcon>
//                 <ListItemText
//                     primary={text}
//                     primaryTypographyProps={{
//                     fontSize: "24px",   
//                     fontWeight: "400", 
//                     }}
//                 />
//               </ListItem>
//             ))}
//           </List>
//         </Box>

//           <Box
//             component="img"
//             src={ParentTrust}
//             alt="Parents and Child"
//             sx={{
//               width: "100%",
//               maxWidth: "500px",
//               borderRadius: "12px",
//             }}
//           />
//         </Box>
//     );
//   }

// export default MedicineDiagnosticDelivery;









import React from "react";
import {
  Typography, Button, Container, Box, Grid, Card,
  CardContent, List, ListItem, ListItemIcon, ListItemText,
  useMediaQuery, useTheme
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Footer from "../../Common/Footer";

import screenimage from "../../Logos/screenimage.png";
import ParentTrust from "../../Logos/Elder&childcarePage/ParentsTrust.png";
import mainimage from "../../Logos/DiagnoisticDelivery/TopBanner.png";
import prescription from "../../Logos/DiagnoisticDelivery/prescription.png";
import refills from "../../Logos/DiagnoisticDelivery/refills.png";
import emergencymedicine from "../../Logos/DiagnoisticDelivery/emergencymedicine.png";
import essentials from "../../Logos/DiagnoisticDelivery/essentials.png";
import coldchain from "../../Logos/DiagnoisticDelivery/coldchain.png";
import MedicineDelivery from "../../Logos/DiagnoisticDelivery/MedicineDelivery.png";
import homesample from "../../Logos/DiagnoisticDelivery/homesample.png";
import widerange from "../../Logos/DiagnoisticDelivery/widerange.png";
import labs from "../../Logos/DiagnoisticDelivery/labs.png";
import digitalreport from "../../Logos/DiagnoisticDelivery/digitalreport.png";
import followup from "../../Logos/DiagnoisticDelivery/followup.png";
import DiagnosticSampleCollection from "../../Logos/DiagnoisticDelivery/DiagnosticSampleCollection.png";

const MedicineDiagnosticDelivery = () => {
  return (
    <Box sx={{ overflowX: "hidden" }}>
      <HeroSection />
      <OverViewSection />
      <MedicineDeliverySection />
      <ScreenImageSection />
      <DiagnosticCollectionSection />
      <ScreenImageSection />
      <WhyAyuja />
      <Footer />
    </Box>
  );
};

// ─── HERO SECTION ─────────────────────────────────────────────────────────────
function HeroSection() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: { xs: "260px", sm: "310px", md: "350px" },
        backgroundImage: `url(${mainimage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        p: { xs: 2, sm: 3, md: 4 },
        color: "#fff",
        position: "relative",
      }}
    >
      <Box
        sx={{
          position: "absolute", top: 0, left: 0, right: 0, bottom: 0,
          bgcolor: "rgba(0,0,0,0.4)",
        }}
      />
      <Box
        sx={{
          position: "relative",
          zIndex: 1,
          ml: { xs: 1, sm: 3, md: 6 },
          mt: { xs: 2, sm: 3, md: 4 },
        }}
      >
        <Typography
          variant="body1"
          sx={{
            mb: 3,
            fontSize: { xs: "26px", sm: "44px", md: "60px", lg: "72px" },
            fontFamily: '"Montserrat", sans-serif',
            lineHeight: "1.2",
            fontWeight: 600,
          }}
        >
          Fast, Reliable Healthcare<br />
          Essentials Delivered to<br />
          Your Doorstep
        </Typography>
      </Box>
    </Box>
  );
}

// ─── OVERVIEW SECTION ─────────────────────────────────────────────────────────
function OverViewSection() {
  return (
    <Box
      sx={{
        minHeight: { xs: "auto", md: "30vh" },
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        px: { xs: 2, sm: 3, md: 4 },
        py: { xs: 3, md: 2 },
        bgcolor: "#fff",
      }}
    >
      <Container>
        <Typography
          variant="h4"
          gutterBottom
          sx={{
            textAlign: "center",
            color: "#000000",
            fontFamily: "Montserrat Alternates, sans-serif",
            fontWeight: "bold",
            fontSize: { xs: "22px", sm: "26px", md: "32px" },
          }}
        >
          Overview
        </Typography>

        <Typography
          variant="body1"
          sx={{
            maxWidth: 1000,
            fontSize: { xs: "14px", sm: "16px", md: "1.3em" },
            color: "#0161AB",
            textAlign: "center",
            mx: "auto",
            lineHeight: 1.7,
          }}
        >
          At{" "}
          <Box component="span" sx={{ fontSize: { xs: "1.3rem", md: "1.8rem" }, fontWeight: "bold" }}>
            Ayuja
          </Box>
          , we understand that timely access to medicines and diagnostic reports is crucial
          for maintaining good health. Our seamless delivery service ensures that prescriptions, medical supplies, and lab reports reach your home safely,
          without the need to step out — especially when you or your loved ones are unwell.
        </Typography>
      </Container>
    </Box>
  );
}

// ─── SHARED CARE CARD ─────────────────────────────────────────────────────────
function CareCard({ service }) {
  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        backgroundColor: "#B3FFC4",
        border: "1.5px solid #B3FFC4",
        borderRadius: 2,
        p: { xs: 1.5, md: 2 },
        width: "100%",
        maxWidth: 320,
        minHeight: { xs: "auto", md: "18vh" },
      }}
    >
      <CardContent sx={{ flexGrow: 1, display: "flex", flexDirection: "column", p: "0 !important" }}>
        <Box display="flex" alignItems="center" sx={{ mb: 2 }}>
          <Box
            sx={{
              width: { xs: 52, md: 62 },
              height: { xs: 52, md: 62 },
              backgroundColor: "#22577A",
              borderRadius: "50%",
              overflow: "hidden",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mr: 2,
              flexShrink: 0,
            }}
          >
            <img
              src={service.image}
              alt={service.title}
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </Box>

          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              fontFamily: '"Montserrat", sans-serif',
              color: "#000000",
              flex: 1,
              wordBreak: "break-word",
              fontSize: { xs: "15px", sm: "16px", md: "18px" },
              lineHeight: 1.3,
            }}
          >
            {service.title}
          </Typography>
        </Box>

        <Typography
          variant="body2"
          sx={{
            fontFamily: '"Montserrat", sans-serif',
            color: "#1a1a1a",
            flexGrow: 1,
            wordBreak: "break-word",
            fontSize: { xs: "15px", sm: "16px", md: "16px" },
            lineHeight: 1.7,
            px: { xs: 0.5, md: 1 },
          }}
        >
          {service.desc}
        </Typography>
      </CardContent>
    </Card>
  );
}

// ─── MEDICINE DELIVERY SECTION ────────────────────────────────────────────────
const medicineServices = [
  { title: "Prescription-Based Delivery", desc: "Upload your prescription, and we'll take care of the rest.", image: prescription },
  { title: "Scheduled Medicine Refills", desc: "Never miss a dose with auto-scheduled refill services.", image: refills },
  { title: "Emergency Medicine Requests", desc: "Priority delivery for critical and time-sensitive medications.", image: emergencymedicine },
  { title: "Chronic Care Essentials", desc: "Hassle-free delivery of medicines for long-term conditions like diabetes, hypertension, and thyroid.", image: essentials },
  { title: "Cold Chain Compliance", desc: "Proper handling and storage of temperature-sensitive medicines during transport.", image: coldchain },
];

function MedicineDeliverySection() {
  return (
    <Box sx={{ backgroundColor: "#006D77", py: 0, mb: 0, position: "relative", overflow: "hidden" }}>
      {/* Decorative image — only on large screens */}
      <Box
        component="img"
        src={MedicineDelivery}
        alt="Medicine Delivery"
        sx={{
          display: { xs: "none", lg: "block" },
          position: "absolute",
          bottom: 0,
          right: 0,
          width: "360px",
          height: "auto",
          pointerEvents: "none",
          zIndex: 0,
        }}
      />

      <Container maxWidth="lg" sx={{ py: 3, position: "relative", zIndex: 1 }}>
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          sx={{
            fontWeight: "bold",
            fontFamily: '"Montserrat", sans-serif',
            color: "#B3FFC4",
            fontSize: { xs: "22px", sm: "26px", md: "30px" },
          }}
        >
          Medicine Delivery
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mb: 3, color: "#B3FFC4", lineHeight: 1.6,
            textAlign: "center", fontSize: { xs: "13px", md: "16px" },
          }}
        >
          Prescriptions at Your Fingertips
        </Typography>

        <Grid container spacing={{ xs: 2, sm: 2.5, md: 3 }} justifyContent="center">
          {medicineServices.map((service, idx) => (
            <Grid item xs={12} sm={6} md={4} key={idx} sx={{ display: "flex", justifyContent: "center" }}>
              <CareCard service={service} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

// ─── SCREEN DIVIDER ───────────────────────────────────────────────────────────
function ScreenImageSection() {
  return (
    <Box
      component="img"
      src={screenimage}
      alt="divider"
      sx={{
        width: "100%",
        height: { xs: "6vh", md: "10vh" },
        objectFit: "cover",
        borderRadius: "0px 0px 100px 0px",
        display: "block",
      }}
    />
  );
}

// ─── DIAGNOSTIC COLLECTION SECTION ───────────────────────────────────────────
const diagnosticServices = [
  { title: "Home Sample Collection", desc: "Certified phlebotomists collect blood, urine, and swab samples at your convenience.", image: homesample },
  { title: "Wide Range of Tests", desc: "From routine health checkups to advanced diagnostics, all tests are covered.", image: widerange },
  { title: "Partnered with Trusted Labs", desc: "We collaborate with NABL-accredited diagnostic centers for accuracy and reliability.", image: labs },
  { title: "Digital Report Access", desc: "Get your reports directly via email or Ayuja app, with printed copies available on request.", image: digitalreport },
  { title: "Doctor Follow-Up Coordination", desc: "Optional consultation scheduling after report delivery for seamless care.", image: followup },
];

function DiagnosticCollectionSection() {
  return (
    <Box sx={{ backgroundColor: "#006D77", py: 0, mb: 0, position: "relative", overflow: "hidden" }}>
      {/* Decorative image — only on large screens */}
      <Box
        component="img"
        src={DiagnosticSampleCollection}
        alt="Diagnostic Sample Collection"
        sx={{
          display: { xs: "none", lg: "block" },
          position: "absolute",
          bottom: 0,
          right: 0,
          width: "380px",
          height: "auto",
          pointerEvents: "none",
          zIndex: 0,
        }}
      />

      <Container maxWidth="lg" sx={{ py: 3, position: "relative", zIndex: 1 }}>
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          sx={{
            fontWeight: "bold",
            fontFamily: '"Montserrat", sans-serif',
            color: "#B3FFC4",
            fontSize: { xs: "18px", sm: "22px", md: "28px" },
          }}
        >
          Diagnostic Sample Collection & Report Delivery
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mb: 3, color: "#B3FFC4", lineHeight: 1.6,
            textAlign: "center", fontSize: { xs: "13px", md: "16px" },
          }}
        >
          Lab Tests Without the Wait
        </Typography>

        <Grid container spacing={{ xs: 2, sm: 2.5, md: 3 }} justifyContent="center">
          {diagnosticServices.map((service, idx) => (
            <Grid item xs={12} sm={6} md={4} key={idx} sx={{ display: "flex", justifyContent: "center" }}>
              <CareCard service={service} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

// ─── WHY AYUJA ────────────────────────────────────────────────────────────────
function WhyAyuja() {
  const trustPoints = [
    "Hassle-free booking through app or helpline",
    "Trained delivery staff and medical professionals",
    "Secure, tamper-proof packaging and verified reports",
    "Timely reminders for reorders and test schedules",
    "Designed for elderly, busy professionals, and post-op patients",
  ];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: "stretch",
        backgroundColor: "#006699",
        color: "white",
        minHeight: { xs: "auto", md: "400px" },
        overflow: "hidden",
      }}
    >
      {/* Left: Text Section */}

      <Box
        sx={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",  
          alignItems: "center",    
          py: { xs: 4, md: 6 },
          px: 2,                  
          order: { xs: 2, md: 1 },
          textAlign: "center",
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontWeight: "bold",justifyContent: "center", alignItems: "center",   
            mb: { xs: 2, md: 3 },
            fontSize: { xs: "20px", sm: "24px", md: "28px", lg: "32px" },
          }}
        >
          Why Choose Ayuja for Medicine & Diagnostic Delivery?
        </Typography>

        <List sx={{ p: 0 }}>
          {trustPoints.map((text, i) => (
            <ListItem key={i} sx={{ py: { xs: 0.8, md: 1.2 }, px: 0, alignItems: "flex-start" }}>
              <ListItemIcon sx={{ minWidth: 40, mt: 0.3 }}>
                <CheckCircleIcon sx={{ color: "#4CAF50", fontSize: { xs: "22px", md: "26px" } }} />
              </ListItemIcon>
              <ListItemText
                primary={text}
                primaryTypographyProps={{
                  fontSize: { xs: "14px", sm: "16px", md: "19px" },
                  fontWeight: "400",
                  color: "white",
                  lineHeight: 1.5,
                }}
              />
            </ListItem>
          ))}
        </List>
      </Box>




 {/* Right: Image — full height cover */}
      <Box
        sx={{
          // On mobile: normal image below text
          // On desktop: fixed width panel, image covers it fully
          width: { xs: "100%", md: "35%", lg: "32%" },
          minHeight: { xs: "260px", md: "100%" },
          order: { xs: 1, md: 2 },
          flexShrink: 0,
          overflow: "hidden",
          position: "relative",
        }}
      >
        <Box
          component="img"
          src={ParentTrust}
          alt="Medicine and Diagnostic Delivery"
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center top",
            display: "block",
            // On mobile keep natural aspect ratio
            minHeight: { xs: "260px", md: "400px" },
          }}
        />
      </Box>
    </Box>
  );
}

export default MedicineDiagnosticDelivery;